/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentMatchFragmentDoc } from './ShipmentMatchFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IShipmentListForCarrierQueryVariables = Types.Exact<{
  carrierId: Types.Scalars['ID']
  matchTypes?: Types.Maybe<
    Array<Types.ILaneCarrierMatchListFilterEnum> | Types.ILaneCarrierMatchListFilterEnum
  >
  after?: Types.Maybe<Types.Scalars['String']>
  before?: Types.Maybe<Types.Scalars['String']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
}>

export type IShipmentListForCarrierQuery = { __typename?: 'Query' } & {
  shipmentListForCarrier: { __typename?: 'LaneCarrierMatchConnection' } & Pick<
    Types.ILaneCarrierMatchConnection,
    'totalCount'
  > & {
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'LaneCarrierMatchEdge' } & Pick<
              Types.ILaneCarrierMatchEdge,
              'cursor'
            > & {
                node?: Types.Maybe<
                  { __typename?: 'LaneCarrierMatch' } & Pick<
                    Types.ILaneCarrierMatch,
                    | 'id'
                    | 'lastRan'
                    | 'hasReservedLane'
                    | 'hasBackhaulHistory'
                    | 'hasHeadhaulHistory'
                    | 'hasLaneAlert'
                    | 'hasReloads'
                    | 'lastRate'
                    | 'strongestMatch'
                  > & {
                      shipment: { __typename?: 'Shipment' } & Pick<
                        Types.IShipment,
                        'id' | 'listRate'
                      > & {
                          equipment: { __typename?: 'Equipment' } & Pick<
                            Types.IEquipment,
                            'id' | 'name'
                          >
                          shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                            Types.IShipperApplication,
                            'id' | 'name'
                          >
                          firstPickup: { __typename?: 'ShipmentStop' } & Pick<
                            Types.IShipmentStop,
                            'id' | 'city' | 'stateCode'
                          > & {
                              appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                                Types.IShipmentStopAppointment,
                                'id' | 'timezone' | 'startAt' | 'endAt' | 'appointmentType'
                              >
                            }
                          lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
                            Types.IShipmentStop,
                            'id' | 'city' | 'stateCode'
                          > & {
                              appointment: { __typename?: 'ShipmentStopAppointment' } & Pick<
                                Types.IShipmentStopAppointment,
                                'id' | 'timezone' | 'startAt' | 'endAt' | 'appointmentType'
                              >
                            }
                        }
                    }
                >
              }
          >
        >
      >
      pageInfo: { __typename?: 'PageInfo' } & Pick<
        Types.IPageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >
    }
}

export const ShipmentListForCarrierDocument = gql`
  query ShipmentListForCarrier(
    $carrierId: ID!
    $matchTypes: [LaneCarrierMatchListFilterEnum!]
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    shipmentListForCarrier(
      carrierId: $carrierId
      matchTypes: $matchTypes
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        cursor
        node {
          ...ShipmentMatch
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
  ${ShipmentMatchFragmentDoc}
`

/**
 * __useShipmentListForCarrierQuery__
 *
 * To run a query within a React component, call `useShipmentListForCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentListForCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentListForCarrierQuery({
 *   variables: {
 *      carrierId: // value for 'carrierId'
 *      matchTypes: // value for 'matchTypes'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useShipmentListForCarrierQuery(
  baseOptions: Apollo.QueryHookOptions<
    IShipmentListForCarrierQuery,
    IShipmentListForCarrierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShipmentListForCarrierQuery, IShipmentListForCarrierQueryVariables>(
    ShipmentListForCarrierDocument,
    options
  )
}
export function useShipmentListForCarrierLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IShipmentListForCarrierQuery,
    IShipmentListForCarrierQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IShipmentListForCarrierQuery, IShipmentListForCarrierQueryVariables>(
    ShipmentListForCarrierDocument,
    options
  )
}
export type ShipmentListForCarrierQueryHookResult = ReturnType<
  typeof useShipmentListForCarrierQuery
>
export type ShipmentListForCarrierLazyQueryHookResult = ReturnType<
  typeof useShipmentListForCarrierLazyQuery
>
export type ShipmentListForCarrierQueryResult = Apollo.QueryResult<
  IShipmentListForCarrierQuery,
  IShipmentListForCarrierQueryVariables
>
